import { video_watch_path } from '../routes';

function markVideoAsWatched(element) {
  var video_slug = element.getAttribute('data-video');
  var url = video_watch_path({ locale: window.I18n.locale, slug: video_slug });
  
  var csrf_token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

  fetch(url, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrf_token,
      'Content-Type': 'application/json'
    }
  })
  .then(res => {
    if (res.ok) {
      if (window.toastr) {
        window.toastr.success(window.I18n.t('video.show.watched'));
      }
    } else {
      element.setAttribute('data-should-watch', 'true');
    }
  })
  .catch(err => {
    console.error('Error marking video as watched:', err);
    element.setAttribute('data-should-watch', 'true');
  });

  element.setAttribute('data-should-watch', 'false');
}

// Global Event Delegation for Video modal triggers (Runs independently of Turbo/Autoload issues)
document.addEventListener('click', (e) => {
  // 1. Open Video Modal Action
  const playBtn = e.target.closest('[data-play-modal="true"]');
  if (playBtn) {
    e.preventDefault();
    const modal = document.getElementById('video-player-modal');
    if (modal) {
      modal.classList.remove('hidden');
      modal.classList.add('flex');
      
      const iframe = modal.querySelector('iframe');
      if (iframe && window.Vimeo) {
        try {
          const player = new Vimeo.Player(iframe);
          player.play().catch(err => console.log('Autoplay deferred:', err));
        } catch(err) {
          console.log('Vimeo error:', err);
        }
      }
    }
    return;
  }

  // 2. Close Video Modal Actions (close buttons or clicking outside content box)
  const modal = document.getElementById('video-player-modal');
  if (modal && !modal.classList.contains('hidden')) {
    const isCloseBtn = e.target.closest('[data-close-modal="true"]') || e.target.closest('#video-player-modal .close');
    const isClickOutside = (e.target === modal) || (modal.contains(e.target) && !e.target.closest('.modal-content'));

    if (isCloseBtn || isClickOutside) {
      e.preventDefault();
      modal.classList.add('hidden');
      modal.classList.remove('flex');
      
      const iframe = modal.querySelector('iframe');
      if (iframe && window.Vimeo) {
        try {
          const player = new Vimeo.Player(iframe);
          player.pause().catch(err => console.log('Pause deferred:', err));
        } catch(err) {
          console.log('Vimeo error:', err);
        }
      }
    }
  }
});

document.addEventListener("turbo:load", () => {
  const modal = document.getElementById('video-player-modal');
  if (modal) {
    const iframe = modal.querySelector('iframe');
    if (iframe) {
      if (window.Vimeo) {
        try {
          const player = new Vimeo.Player(iframe);

          player.on('timeupdate', function(data) {
            if (data.percent >= 0.75 && iframe.getAttribute('data-should-watch') === "true") {
              markVideoAsWatched(iframe);
            }
          });
        } catch (e) {
          console.log("Vimeo tracker error:", e);
        }
      }
    }
  }

  // Hover pre-loaded previews with delegation-style click handlers
  document.querySelectorAll(".card-lesson, .card-next-lesson").forEach(el => {
    el.addEventListener('mouseover', function() {
      const previewable_container = el.querySelector('.previewable');
      if (!previewable_container) return;

      if (previewable_container.querySelector('.preview')) return;

      const staticImg = previewable_container.querySelector('.static-image');
      if (!staticImg) return;

      const preview_url = staticImg.getAttribute('data-preview');
      if (!preview_url) return;

      const preview_el = document.createElement('img');
      preview_el.className = 'img-responsive preview';
      preview_el.src = preview_url;

      previewable_container.appendChild(preview_el);
    });
  });
});
